import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  class: "canvasBox"
};
const _hoisted_2 = {
  key: 0,
  class: "box2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.isUse ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "box"
  }, [_createElementVNode("div", {
    class: "line"
  }), _createElementVNode("div", {
    class: "angle"
  })], -1)), $data.isUseTorch ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
    class: "track",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.openTrack && $options.openTrack(...args))
  }, [_createElementVNode("div", {
    style: _normalizeStyle(`color: ${$data.trackStatus ? '#fff' : '#666'}`)
  }, _cache[1] || (_cache[1] = [_createElementVNode("svg", {
    t: "1723703347534",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "2421",
    width: "48",
    height: "48",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [_createElementVNode("path", {
    d: "M613.610667 56.661333c14.570667-18.453333 21.696-15.082667 15.829333 8l-74.048 290.88 243.413333 73.173334c11.178667 3.349333 14.549333 13.653333 7.488 23.04L418.773333 967.893333c-14.186667 18.901333-20.906667 15.786667-14.933333-7.146666l78.378667-301.568-281.194667-49.429334c-11.605333-2.048-15.189333-11.072-7.744-20.522666L613.610667 56.661333z",
    fill: "currentColor",
    "p-id": "2422"
  })], -1)]), 4), _createTextVNode(" " + _toDisplayString($data.trackStatus ? '关闭闪光灯' : '打开闪光灯'), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "mask1 mask",
    style: _normalizeStyle('height:' + $data.maskHeight + 'px;')
  }, null, 4), _createElementVNode("div", {
    class: "mask2 mask",
    style: _normalizeStyle('width:' + $data.maskWidth + 'px;top:' + $data.maskHeight + 'px;height:' + $data.canvasHeight + 'px')
  }, null, 4), _createElementVNode("div", {
    class: "mask3 mask",
    style: _normalizeStyle('height:' + $data.maskHeight + 'px;')
  }, null, 4), _createElementVNode("div", {
    class: "mask4 mask",
    style: _normalizeStyle('width:' + $data.maskWidth + 'px;top:' + $data.maskHeight + 'px;height:' + $data.canvasHeight + 'px')
  }, null, 4)], 64)) : _renderSlot(_ctx.$slots, "error", {
    key: 1
  }, () => [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "error"
  }, [_createElementVNode("div", {
    class: "on1"
  }, "相机权限被拒绝，请尝试如下操作："), _createElementVNode("div", null, "· 刷新页面后重试；"), _createElementVNode("div", null, "· 在系统中检测当前App或浏览器的相机权限是否被禁用；"), _createElementVNode("div", null, "· 如果依然不能体验，建议在微信中打开链接；")], -1))], true)]);
}